/** Quote a CSV cell, escaping any embedded quotes / commas / newlines. */
const cell = (v: unknown): string => {
  if (v === null || v === undefined) return "";

  const s = typeof v === "string" ? v : String(v);

  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }

  return s;
};

export const toCsv = (
  headers: string[],
  rows: Array<Array<string | number | null | undefined>>,
): string => {
  const lines = [headers.map(cell).join(",")];

  for (const r of rows) {
    lines.push(r.map(cell).join(","));
  }

  return lines.join("\r\n");
};

export const downloadCsv = (filename: string, csv: string): void => {
  // BOM helps Excel detect UTF-8.
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a tick — some browsers need the URL alive long enough to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
